import { createFileRoute, redirect } from '@tanstack/react-router'
import i18next from 'i18next'
import { enqueueSnackbar } from 'notistack'
import { lightningReportsQuery } from '../../data/reports/lightning.ts'
import { DisplayLightningReport } from '../../features/reports/display-form/lightning/DisplayLightningReport.tsx'
import { LightningReportSearchSchema } from '../../features/reports/display-form/lightning/reportSearch.ts'
import { flagVariation } from '../../launchdarkly.ts'

export const Route = createFileRoute('/_app/reports/lightning/$id')({
	validateSearch: LightningReportSearchSchema,
	shouldReload: false,
	component: DisplayLightningReport,
	beforeLoad: ({ context: { isAdmin, isLimitedAdmin, sub, impersonation } }) => {
		if ((!isAdmin && !isLimitedAdmin) || (!impersonation && !sub.features.includes('analyze'))) {
			throw redirect({ to: '/' })
		}
	},
	loader: async ({ params: { id }, context: { queryClient, impersonation, ldClient } }) => {
		const analyzeV2 = !!ldClient && flagVariation(ldClient, 'analyzeV2LightningReports')
		const reports = await queryClient.ensureQueryData(lightningReportsQuery(impersonation, analyzeV2))

		const report = reports.find((report) => report.id === id)
		if (report?.status !== 'COMPLETED') {
			enqueueSnackbar({ variant: 'error', message: i18next.t(($) => $.reports.display.reportDoesNotExistOrIsNotProcessed) })
			throw redirect({ to: '/reports' })
		}

		return { report }
	},
})
